{
  "checkIn": {
    "confirmation": {
      "pdf_v2": {
        "buttonText": "Download (v2)"
      }
    }
  },
  "subHeader": {
    "backToMyBookings": "Exit trip",
    "backToMyBookingsAria": "Exit trip"
  },
  "reviewPage": {
    "backButtonTravelExtras": "Travel extras"
  },
  "disruption": {
    "notices": {
      "tripChanged": {
        "title": "Your trip to {city} has changed."
      }
    },
    "flight": {
      "newFlight": "New flight",
      "unchanged": "Unchanged",
      "previously": "Previously"
    },
    "connection": {
      "transferTime": "Transfer time"
    },
    "steps": {
      "continueToReturn": "Continue to return flight",
      "continueToReview": "Continue to review page",
      "confirm": "Confirm new flights",
      "checkOtherOptions": "Check other options",
      "cancelFlights": "Cancel flights",
      "departureTitle": "New departure flight",
      "returnTitle": "New return flight",
      "reviewTitle": "Review and confirm your new travel plan",
      "asBooked": "As booked",
      "back": "Back"
    }
  }
}
